import * as React from 'react';
import {Dispatch} from 'redux';
import {connect} from 'react-redux';
import {Cell, AppLogo, ClassNameBuilder} from '@openfin/desktop-ui';

import {ApplicationPin} from '../ApplicationPin/ApplicationPin';
import {App, AppStatusStates} from '../../../types/commons';
import {LaunchApp, UpdateAppStatus} from '../../../store/partials/Directory';
import * as AnimationStyles from '../../styles/animations.module.scss';
import {isOmnibar} from '../../../utils/processHelpers';

import * as Styles from './ApplicationEntry.module.scss';

interface Props {
    item: App;
    status: AppStatusStates;
    launchApp: (app: App) => void;
    updateAppStatus: (app: App, status: AppStatusStates) => void;
}

const ApplicationEntryComponent = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
    const {launchApp, updateAppStatus, item, status} = props;
    const entryClass = new ClassNameBuilder(undefined)
        .add(['loading', status === AppStatusStates.Loading], AnimationStyles)
        .add(['error', status === AppStatusStates.Error], AnimationStyles)
        .toString();

    const handleClick = () => {
        launchApp(item);
    };

    React.useEffect(() => {
        return () => {
            if (status === AppStatusStates.Error) {
                updateAppStatus(item, AppStatusStates.Closed);
            }
        };
    }, [status]);

    return (
        <Cell ref={ref} text={item.title} className={entryClass} onClick={handleClick} image={<AppLogo src={item.icon} />}>
            {!isOmnibar() && <ApplicationPin app={item} className={Styles['button']} />}
        </Cell>
    );
});

const mapDispatch = (dispatch: Dispatch) => ({
    launchApp: (app: App) => dispatch(new LaunchApp(app)),
    updateAppStatus: (app: App, status: AppStatusStates) => dispatch(new UpdateAppStatus(app, status))
});

export const ApplicationEntry = connect(undefined, mapDispatch, undefined, {forwardRef: true})(ApplicationEntryComponent);
